import { lazy } from "react";
// Clinical Operations Dashboard Module (Module L — BillingV2 Stage 2)
// Operational control across centers: workloads, backlog and risk distribution.

const ClinicalOperationsPage = lazy(() => import("./pages/ClinicalOperationsPage"));
// Export routes for AppRouter
export const clinicalOperationsRoutes = [
  {
    path: "/clinical-operations",
    element: <ClinicalOperationsPage />,
  },
];

// Export components for external use
